// 5050 SLIDER
const fiftyFiftySliderSections = document.querySelectorAll('.o-sec.fifty-fifty-slider');
if(fiftyFiftySliderSections.length > 0) {
  fiftyFiftySliderSections.forEach(function(sliderSection) {
    const slider = sliderSection.querySelector('.c-slider');
    const sliderNavLinks = sliderSection.querySelectorAll('.c-slider-nav_link');
    const sliderBtns = sliderSection.querySelectorAll('.c-5050-slider_btn');

    // INIT SLIDER
    const fiftyFiftySlider = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 600,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        // pauseOnMouseEnter: true,
      },
      loop: true,
      navigation: {
        nextEl: '.c-slider-arrows .c-slider-arrow.next',
        prevEl: '.c-slider-arrows .c-slider-arrow.prev',
      },
      allowTouchMove: false,
      autoHeight: true,
      breakpoints: {
        992: {
          autoHeight: false
        }
      }
    });

    // PAGINATION BULLET CHANGE
    fiftyFiftySlider.on('slideChange', function(swiper) {
      const currentSlideIndex = swiper.realIndex;        
      const sliderBullets = sliderSection.querySelectorAll('.c-slider-bullet');
      sliderBullets.forEach(function(bullet, index) {
        if( index === currentSlideIndex ) {
          bullet.classList.add('active');
        } else {
          bullet.classList.remove('active');
        }
      });


      sliderNavLinks.forEach(function(sliderNavLink) {
        sliderNavLink.classList.remove('active');
      });
      sliderNavLinks[currentSlideIndex].classList.add('active');

      if(sliderBtns.length > 0) {
        sliderBtns.forEach(function(btn) {
          btn.classList.remove('active');
        });
        if(sliderBtns[currentSlideIndex]) {
          sliderBtns[currentSlideIndex].classList.add('active');
        }
      }
    });

    // NAV LINK CLICKS MOVE TO SLIDE
    sliderNavLinks.forEach(function(sliderNavLink) {
      sliderNavLink.addEventListener('click', function(e) {
        e.preventDefault();

        const slideIndex = Array.from(sliderNavLinks).indexOf(sliderNavLink);
        fiftyFiftySlider.slideTo(slideIndex);

        // SET ACTIVE NAV LINK
        sliderNavLinks.forEach(function(link) {
          link.classList.remove('active');
        });
        sliderNavLink.classList.add('active');

        // SET ACTIVE BUTTON
        sliderBtns.forEach(function(btn) {
          btn.classList.remove('active');
        });
        sliderBtns[slideIndex].classList.add('active');
      });
    });
  });
}